const sidePadding = 15;
const sectionStyle = {
  padding: [0, sidePadding],
};

const styles = theme => ({
  modalSpin: {
    display: 'block',
    textAlign: 'center',
  },
  modalTitle: {
    textAlign: 'center',
    width: '100%',
    display: 'block',
    marginBottom: '20px',
    fontWeight: '600',
  },
  announcementPopup: {
    '& .ant-tabs': {
      color: 'white',
      height: '50vh',
    },
    '& .ant-tabs-tab': {
      whiteSpace: 'pre-wrap',
      textAlign: 'left !important',
      padding: '2px 10px !important',
    },
    '& .ant-tabs-left >.ant-tabs-nav': {
      width: '30%',
    },
    '& .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn': {
      color: '#F3B331',
    },
    '& .ant-tabs-ink-bar': {
      backgroundColor: '#F3B331',
    },
    '& .ant-tabs-tab:hover': {
      color: '#cfcfcf',
    },
    '& .ant-tabs-content-holder': {
      overflowY: 'auto',
    },
    '& .ant-tabs-content': {
      backdropFilter: 'blur(1px)',
      whiteSpace: 'pre-wrap',
    },
  },
  // todo have problem here
  leftMenu: {
    // width: '373px',
    height: '100%',
    padding: '60px 0px 0px 35px',
    fontSize: '18px',
  },
  // or 100vh?
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    // minHeight: 'calc(110px + 100vh)',
    height: 'auto',
    overflowY: 'auto',
    background: theme.backgroundColor,
    boxShadow:
      '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10)',
    '& .ant-layout-sider-children': {
      display: 'flex',
      flexDirection: 'column',
      background: '#0B0910',
      height: '100%',
    },
  },

  // web 3 design
  asideContentContainer: {
    // marginTop: 107,
    display: 'flex',
    flexDirection: 'column',
    background: theme.backgroundColor,
    height: '100vh',
  },
  upperPartSection: {
    background: theme.backgroundColor,
    // flex: '0 0 226px',
    flex: '0 0 174px',
  },
  upperPartWrapper: {
    marginTop: 72,
  },
  siderButtonRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
    marginTop: 15,
  },
  siderButton: {
    width: '100%',
    padding: '10px 10px',
    height: 'fit-content',
  },
  userProfileSection: {
    extend: sectionStyle,
    marginBottom: '10px',
  },
  buttonSection: {
    marginLeft: '15px',
    marginRight: '27px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  navigationSection: {
    '& ul > li': {
      paddingLeft: '26px !important',
    },
    flex: '0 1 0',
  },
  menuInDrawer: {
    color: 'white',
    fontSize: '17px',
    '&.ant-menu.ant-menu-dark': {
      background: theme.backgroundColor,
    },
  },
  menuItem: {
    margin: 0,
    borderRadius: 0,
    '& .ant-menu-title-content': {
      display: 'flex',
      alignItems: 'center',
      '& > span:not(:last-child)': {
        marginLeft: 10,
      },
    },
    '&.ant-menu-item, &.ant-menu-vertical.ant-menu-item:not(:last-child)': {
      margin: '0px !important',
      height: '60px',
      display: 'flex',
    },
    '&.ant-menu-item-selected': {
      '&:before': {
        content: '""',
        borderRadius: '0px 5px 6px 0px',
        background: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%)',
        position: 'absolute',
        top: 0,
        left: 0,
        width: 5,
        height: '100%',
      },
      backgroundColor: theme.backgroundColor,
      '& $menuText': {
        background: 'linear-gradient(180deg, #33C4E8 0%, #4A65F2 100%)',
        backgroundClip: 'text',
        '-webkit-text-fill-color': 'transparent',
      },

      '& svg': {
        '& path': {
          fill: 'url(#home_svg__paint0_linear_9_5855) !important',
          opacity: 1,
        },
      },
    },

    '&.ant-menu-item': {
      background: [theme.backgroundColor, '!important'],
      '& $menuText': {
        color: 'rgba(255, 255, 255, 0.5)',
      },

      '& .anticon': {
        display: 'block',
      },
      '& svg': {
        fontSize: 30,
        '& path': {
          fill: 'rgba(255, 255, 255, 1)',
        },
      },
      '&:hover:not(.ant-menu-item-selected)': {
        background: theme.backgroundColor,
        '& span': {
          '& a': {
            color: 'rgba(255, 255, 255, 0.65)',
          },
        },
      },
    },
    '& a': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  menuIcon: {
    minWidth: 24,
    width: 30,
    height: 30,
    marginRight: 15,
  },
  menuText: {
    color: theme.textColor,

    fontSize: 16,
  },
  indentedSectionsContainer: {
    padding: [0, 20],
    flex: '0 0 40%',
    display: 'flex',
    flexDirection: 'column',
  },
  languageSelectorSection: {
    // extend: sectionStyle,
    marginTop: 10,
  },
  languageSelector: {
    minWidth: 140,
    height: 40,
    width: '100%',
  },
  languageIcon: {
    marginRight: 10,
    width: '15px !important',
    height: '15px !important',
    fontSize: '20px',
  },
  quickAccessSection: {
    extend: sectionStyle,
    marginTop: 78,
    '& a': {
      color: '#FFFFFF',
    },
    '& ul': {
      listStyleType: 'none',
      paddingInlineStart: 0,
      '& > li:not(:last-child)': {
        marginBottom: 10,
      },
    },
  },
  footerSection: {
    extend: [sectionStyle, 'quickAccessSection'],
    marginTop: 30,
    '& a': {
      color: theme.secondaryTextColor,
    },
  },
  footerButton: {
    padding: 0,
    height: 'unset',
    color: theme.secondaryTextColor,
    fontSize: 14,
    marginBottom: 10,
    '&:hover': {
      cursor: 'pointer',
      color: theme.secondaryTextColor,
    },
  },
  modalBodyTitle: {
    color: 'white',
  },
  modalBodyContent: {
    fontSize: 12,
    paddingInlineStart: '1em',
  },
});

export default styles;
